/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RichTextSectionParameters
 */
export interface RichTextSectionParameters {
    /**
     * 
     * @type {string}
     * @memberof RichTextSectionParameters
     */
    value: string;
}

/**
 * Check if a given object implements the RichTextSectionParameters interface.
 */
export function instanceOfRichTextSectionParameters(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function RichTextSectionParametersFromJSON(json: any): RichTextSectionParameters {
    return RichTextSectionParametersFromJSONTyped(json, false);
}

export function RichTextSectionParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): RichTextSectionParameters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function RichTextSectionParametersToJSON(value?: RichTextSectionParameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

